import { Fragment, ReactNode } from "react";
import { BackNavigation } from "../Navigation/BackNavigation";
import { SubNavigation } from "../Navigation/SubNavigation";
import { SelectYourNumber } from "../SelectYourNumber/SelectYourNumber";

interface IParams {
    children: ReactNode;
    hasDefault?: boolean;
    requireNumberSelection?: boolean;
    selectYourNumberTitle?: string;
    title: string;
}

export const AccountDetailsLayout = (props: IParams) => {
    const { children, hasDefault, requireNumberSelection = false, selectYourNumberTitle, title } = props;

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <BackNavigation title={title} />
                {requireNumberSelection && (
                    <SelectYourNumber hasDefault={hasDefault} titleContent={selectYourNumberTitle}>
                        {children}
                    </SelectYourNumber>
                )}
                {!requireNumberSelection && children}
            </div>
        </Fragment>
    );
};
